import ErrorMessage from './ErrorMessage'
import ErrorMessageText from './ErrorMessageText'
export { ErrorMessageText }
export default ErrorMessage
